import { render, staticRenderFns } from "./ClockIcon.vue?vue&type=template&id=d37d2852&"
import script from "./ClockIcon.vue?vue&type=script&lang=ts&"
export * from "./ClockIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ClockIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports